/**
 * @author Lorenzo Muscariello <lmuscariello@ciaopeople.com>
 */

import { isPlayerAdEvent } from "@mp-commons/modules/ads/PlayerAdEvent.js";
import { PlayerEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { MegaridePlayer } from "./MegaridePlayer.js";


export const EVT_PREFIX = "megaride";



function useName(evt: PlayerEvent): string {
    return EVT_PREFIX + (isPlayerAdEvent(evt)?":ad":":video");
}


/**
 * dispatches player events on selected event target
 * @param player 
 * @param target 
 * @param canalized if true video and ad events are given different names (megaride:video, megaride:ad) instead of megaride
 */
export function dispatchMegarideEvents(
    player: MegaridePlayer,
    target: EventTarget,
    canalized: boolean = false
) {   

    player.getControls().onPlayerEvent((event) => {

        const evtName = canalized?useName(event):EVT_PREFIX;

        const customEvent = 
            new CustomEvent(evtName,{
                detail: {
                    data: event,
                    player: player
                }
            });
        target.dispatchEvent(customEvent);
    });

}


export class MegarideEventsProxyInterface {

    constructor(private target: EventTarget) {

    }


    onPlayerEvents(listener: EventListener): void {
        this.target.addEventListener(EVT_PREFIX,listener);
    }

    offPlayerEvents(listener: EventListener): void {
        this.target.removeEventListener(EVT_PREFIX,listener);
    }


}
